import { render } from "./LoadingApp.vue?vue&type=template&id=cc597a56"
import script from "./LoadingApp.vue?vue&type=script&lang=js"
export * from "./LoadingApp.vue?vue&type=script&lang=js"

import "./LoadingApp.vue?vue&type=style&index=0&id=cc597a56&lang=scss"

import exportComponent from "/home/nathan/public_html/accident-plan/accident-plan-api-whitelabel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__